import EditFeatureFlagForm  from '../components/Forms/EditFeatureFlagForm';
import { useLocation } from "react-router-dom";

function EditFeatureFlagPage() {
    // Load featureFlag data here then pass into the form
    const location = useLocation();
    const featureFlagName = location.state.featureFlagName || "";
    const serviceName = location.state.serviceName || "";
    
    return <section style={{margin: "20px"}}>
        <h1>Edit Feature Flag</h1>

        <EditFeatureFlagForm
        featureFlagName={featureFlagName}
        serviceName={serviceName}
        />
    </section>
}

export default EditFeatureFlagPage;